import { z } from "zod";
import { copilotProposalIdSchema } from "./copilotProposal.js";
import {
  playbookSelectionSchema
} from "./playbook.js";
const signalIdSchema = z.uuid().brand();
function asSignalId(id) {
  return signalIdSchema.parse(id);
}
const metadataFieldIdSchema = z.uuid().brand();
function asMetadataFieldId(id) {
  return metadataFieldIdSchema.parse(id);
}
const SIGNAL_METADATA_KEY_MAX_LENGTH = 100;
const signalMetadataKeySchema = z.string().min(1).max(
  SIGNAL_METADATA_KEY_MAX_LENGTH,
  `Field labels must be ${SIGNAL_METADATA_KEY_MAX_LENGTH} characters or fewer.`
);
const signalMetadataSchemaEnumSchema = z.object({
  id: metadataFieldIdSchema,
  key: signalMetadataKeySchema,
  type: z.literal("enum"),
  options: z.array(z.string().min(1)).min(1)
});
const signalMetadataSchemaNumberSchema = z.object({
  id: metadataFieldIdSchema,
  key: signalMetadataKeySchema,
  type: z.literal("number")
});
const signalMetadataSchemaFieldSchema = z.discriminatedUnion("type", [
  signalMetadataSchemaEnumSchema,
  signalMetadataSchemaNumberSchema
]);
const MAX_METADATA_FIELDS = 10;
const signalMetadataSchemaSchema = z.object({
  fields: z.array(signalMetadataSchemaFieldSchema).max(MAX_METADATA_FIELDS)
});
function isValidMetadataField(field) {
  if (field.type === "enum") {
    return field.options.length > 0;
  }
  return true;
}
const SIGNAL_NAME_MAX_LENGTH = 200;
const SIGNAL_DESCRIPTION_MAX_LENGTH = 5e3;
const signalNameSchema = z.string().min(1).max(
  SIGNAL_NAME_MAX_LENGTH,
  `Name must be ${SIGNAL_NAME_MAX_LENGTH} characters or fewer.`
);
const signalDescriptionSchema = z.string().min(1).max(
  SIGNAL_DESCRIPTION_MAX_LENGTH,
  `Description must be ${SIGNAL_DESCRIPTION_MAX_LENGTH.toLocaleString("en-US")} characters or fewer.`
);
const signalPayloadSchema = z.object({
  name: signalNameSchema,
  description: signalDescriptionSchema,
  metadata_schema: signalMetadataSchemaSchema.optional(),
  playbook_scope: playbookSelectionSchema
});
const signalCreatePayloadSchema = signalPayloadSchema.extend({
  proposal_id: copilotProposalIdSchema.optional()
});
function toSignalAdminApp(db) {
  return {
    id: db.id,
    created_at: db.created_at,
    updated_at: db.updated_at,
    name: db.name,
    description: db.description,
    metadata_schema: db.metadata_schema,
    playbook_scope: db.playbook_scope,
    live_version_id: db.live_version_id
  };
}
export {
  MAX_METADATA_FIELDS,
  SIGNAL_DESCRIPTION_MAX_LENGTH,
  SIGNAL_METADATA_KEY_MAX_LENGTH,
  SIGNAL_NAME_MAX_LENGTH,
  asMetadataFieldId,
  asSignalId,
  isValidMetadataField,
  metadataFieldIdSchema,
  signalCreatePayloadSchema,
  signalDescriptionSchema,
  signalIdSchema,
  signalMetadataKeySchema,
  signalMetadataSchemaFieldSchema,
  signalMetadataSchemaSchema,
  signalNameSchema,
  signalPayloadSchema,
  toSignalAdminApp
};
//# sourceMappingURL=signal.js.map
